export enum CustomReport {
  type = 'custom',
  dateType = 'createdon',
}

export enum DateTypeApiTransform {
  'booking' = 'createdon',
  'check-in' = 'checkin',
  'check-out' = 'checkout',
}
